import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../api/axiosInstance";

type LoginPayload = {
  email: string;
  password: string;
};

interface LoginState {
  loading: boolean;
  error: string | { message?: string } | null;
  user: any;
}

export const Adminlogin = createAsyncThunk(
  "login/Adminlogin",
  async ({ email, password }: LoginPayload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/login`, {
        email,
        password,
      });
      const token = response.data.token;
      localStorage.setItem("token", token);
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

const initialState: LoginState = {
  loading: false,
  error: null,
  user: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logout: (state) => {
      state.loading = false;
      state.error = null;
      state.user = null;
      localStorage.removeItem("token");
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(Adminlogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(Adminlogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(Adminlogin.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "An unknown error occurred";
      });
  },
});

export const { logout, clearError } = loginSlice.actions;

export default loginSlice.reducer;
